import { IEspmPropertyTypeTaxonomyResponse } from "../contracts/EspmPropertyType";
import { IZeosApiResponse } from "../contracts/ZeosApi";
import { getDataAsync } from "../ZeosApiExecutor";
import { IEspmPropertyType } from "./interfaces/IEspmPropertyType";

const BASE_URL = `/EspmPropertyType`;

export const EspmPropertyType: IEspmPropertyType = {
  getTaxonomyAsync: async (): Promise<
    IZeosApiResponse<IEspmPropertyTypeTaxonomyResponse>
  > => {
    return await getDataAsync<IEspmPropertyTypeTaxonomyResponse>(
      `${BASE_URL}/Taxonomy`,
      ""
    );
  },
};
